import { createContext, useContext } from 'react';

import type { ChildrenMetaFunction } from '../DeleteModal';

export type ConfirmOptions = {
	title?: string;
	message?: React.ReactNode;
	confirmText?: string;
	cancelText?: string;
};

export type ConfirmResult<T = unknown> = [boolean, T];

export type AsyncConfirmFn<T = unknown> = (
	options: ConfirmOptions,
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	nodeFn?: ChildrenMetaFunction<any>,
	defaultMeta?: T,
	isMetaValid?: (meta: T | undefined) => boolean
) => Promise<ConfirmResult<T>>;

export type ConfirmContextValue = {
	confirm: AsyncConfirmFn;
};

export const ConfirmModalContext = createContext<ConfirmContextValue | undefined>(undefined);

export const useAsyncConfirm = <T = unknown>(): AsyncConfirmFn<T> => {
	const ctx = useContext(ConfirmModalContext);
	if (!ctx) {
		throw new Error('useAsyncConfirm must be used within a ConfirmProvider');
	}
	return ctx.confirm as AsyncConfirmFn<T>;
};
